// Order ID Input Masking - Global Theme Script
// Handles Amazon (.amazon-id) and Walmart (.walmart-id) order formats
// Amazon: 999-9999999-9999999 | Walmart: 9999999-99999999
//
// Usage in HTML:
// <input class="amazon-id" placeholder="Amazon Order ID">
// <input class="walmart-id" placeholder="Walmart Order ID">


(function() {
    'use strict';

    // Main function to apply input masks to all order ID fields
    function applyOrderIdMaskToAllForms() {
        // Find all potential form containers
        const formContainers = [
            ...document.querySelectorAll('.globo-formbuilder'),
            ...document.querySelectorAll('form'),
            ...document.querySelectorAll('[class*="form"]'),
            ...document.querySelectorAll('[class*="contact"]')
        ];
        
        console.log(`Order Masking: Found ${formContainers.length} potential form containers`);
        
        // Debug: Log all inputs with amazon or walmart in their classes
        const debugInputs = document.querySelectorAll('input[class*="amazon"], input[class*="walmart"]');
        if (debugInputs.length > 0) {
            console.log('Order Masking Debug: Found inputs with amazon/walmart classes:', debugInputs);
            debugInputs.forEach(input => {
                console.log(`  - Input classes: "${input.className}", name: "${input.name}", placeholder: "${input.placeholder}"`);
            });
        }
        
        formContainers.forEach((container, index) => {
            const containerId = container.getAttribute('data-id') || 
                               container.getAttribute('id') || 
                               `form-${index}`;
            
            // Look for Amazon Order ID fields using specific class selector
            const amazonSelectors = [
                'input.amazon-id',                         // Amazon order ID class
                'input[class*="amazon-id"]',               // Partial class match
                '.amazon-id input',                        // Input inside amazon-id container
                '[class*="amazon-id"] input'              // Input inside container with amazon-id class
            ];
            
            // Look for Walmart Order ID fields using specific class selector
            const walmartSelectors = [
                'input.walmart-id',                        // Walmart order ID class
                'input[class*="walmart-id"]',              // Partial class match
                '.walmart-id input',                       // Input inside walmart-id container
                '[class*="walmart-id"] input'             // Input inside container with walmart-id class
            ];
            
            // Check for Amazon fields
            let amazonInput = null;
            for (let selector of amazonSelectors) {
                amazonInput = container.querySelector(selector);
                if (amazonInput && !amazonInput.hasAttribute('data-amazon-mask-applied')) {
                    console.log(`Amazon Order Mask: Found Amazon input in ${containerId} using selector: ${selector}`);
                    
                    // Remove any existing listeners to avoid duplicates
                    amazonInput.removeEventListener('input', formatAmazonOrderId);
                    amazonInput.removeEventListener('keydown', handleAmazonBackspace);
                    amazonInput.removeEventListener('paste', handleAmazonPaste);
                    
                    // Add the Amazon masking event listeners
                    amazonInput.addEventListener('input', formatAmazonOrderId);
                    amazonInput.addEventListener('keydown', handleAmazonBackspace);
                    amazonInput.addEventListener('paste', handleAmazonPaste);
                    
                    // Mark as processed to avoid duplicates
                    amazonInput.setAttribute('data-amazon-mask-applied', 'true');
                    
                    // Add helpful Amazon-specific placeholder if none exists
                    if (!amazonInput.placeholder) {
                        amazonInput.placeholder = 'Amazon: 123-4567890-1234567';
                    }
                    
                    console.log(`Amazon Order Mask: Applied successfully to ${containerId}`);
                    break;
                }
            }
            
            // Check for Walmart fields
            let walmartInput = null;
            for (let selector of walmartSelectors) {
                walmartInput = container.querySelector(selector);
                if (walmartInput && !walmartInput.hasAttribute('data-walmart-mask-applied')) {
                    console.log(`Walmart Order Mask: Found Walmart input in ${containerId} using selector: ${selector}`);
                    
                    // Remove any existing listeners to avoid duplicates
                    walmartInput.removeEventListener('input', formatWalmartOrderId);
                    walmartInput.removeEventListener('keydown', handleWalmartBackspace);
                    walmartInput.removeEventListener('paste', handleWalmartPaste);
                    
                    // Add the Walmart masking event listeners
                    walmartInput.addEventListener('input', formatWalmartOrderId);
                    walmartInput.addEventListener('keydown', handleWalmartBackspace);
                    walmartInput.addEventListener('paste', handleWalmartPaste);
                    
                    // Mark as processed to avoid duplicates
                    walmartInput.setAttribute('data-walmart-mask-applied', 'true');
                    
                    // Add helpful Walmart-specific placeholder if none exists
                    if (!walmartInput.placeholder) {
                        walmartInput.placeholder = 'Walmart: 1234567-12345678';
                    }
                    
                    console.log(`Walmart Order Mask: Applied successfully to ${containerId}`);
                    break;
                }
            }
        });
    }

    // ===== AMAZON ORDER ID FUNCTIONS =====
    // Format Amazon order ID input with mask: 999-9999999-9999999
    function formatAmazonOrderId(e) {
        let value = e.target.value.replace(/\D/g, ''); // Remove all non-digits
        let formattedValue = '';
        
        // Apply the Amazon order ID format: 999-9999999-9999999
        if (value.length > 0) {
            if (value.length <= 3) {
                formattedValue = value;
            } else if (value.length <= 10) {
                formattedValue = `${value.slice(0,3)}-${value.slice(3)}`;
            } else if (value.length <= 17) {
                formattedValue = `${value.slice(0,3)}-${value.slice(3,10)}-${value.slice(10,17)}`;
            } else {
                // Limit to 17 digits maximum
                formattedValue = `${value.slice(0,3)}-${value.slice(3,10)}-${value.slice(10,17)}`;
            }
        }
        
        e.target.value = formattedValue;
    }

    // Handle backspace for Amazon order IDs
    function handleAmazonBackspace(e) {
        if (e.key === 'Backspace') {
            let cursorPos = e.target.selectionStart;
            let value = e.target.value;
            
            // If cursor is right after a dash, move it back one more position
            if (cursorPos > 0 && value[cursorPos - 1] === '-') {
                setTimeout(() => {
                    e.target.setSelectionRange(cursorPos - 1, cursorPos - 1);
                }, 0);
            }
        }
    }

    // Handle paste events for Amazon order IDs
    function handleAmazonPaste(e) {
        e.preventDefault();
        let paste = (e.clipboardData || window.clipboardData).getData('text');
        let cleanPaste = paste.replace(/\D/g, ''); // Remove non-digits
        
        if (cleanPaste.length <= 17) {
            e.target.value = cleanPaste;
            // Trigger input event to apply formatting
            e.target.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }

    // ===== WALMART ORDER ID FUNCTIONS =====
    // Format Walmart order ID input with mask: 9999999-99999999
    function formatWalmartOrderId(e) {
        let value = e.target.value.replace(/\D/g, ''); // Remove all non-digits
        let formattedValue = '';
        
        // Apply the Walmart order ID format: 9999999-99999999
        if (value.length > 0) {
            if (value.length <= 7) {
                formattedValue = value;
            } else if (value.length <= 15) {
                formattedValue = `${value.slice(0,7)}-${value.slice(7,15)}`;
            } else {
                // Limit to 15 digits maximum
                formattedValue = `${value.slice(0,7)}-${value.slice(7,15)}`;
            }
        }
        
        e.target.value = formattedValue;
    }

    // Handle backspace for Walmart order IDs
    function handleWalmartBackspace(e) {
        if (e.key === 'Backspace') {
            let cursorPos = e.target.selectionStart;
            let value = e.target.value;
            
            // If cursor is right after a dash, move it back one more position
            if (cursorPos > 0 && value[cursorPos - 1] === '-') {
                setTimeout(() => {
                    e.target.setSelectionRange(cursorPos - 1, cursorPos - 1);
                }, 0);
            }
        }
    }

    // Handle paste events for Walmart order IDs
    function handleWalmartPaste(e) {
        e.preventDefault();
        let paste = (e.clipboardData || window.clipboardData).getData('text');
        let cleanPaste = paste.replace(/\D/g, ''); // Remove non-digits
        
        if (cleanPaste.length <= 15) {
            e.target.value = cleanPaste;
            // Trigger input event to apply formatting
            e.target.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }

    // ===== SHARED UTILITY FUNCTIONS =====
    // Observe DOM for dynamically loaded forms
    function observeForNewForms() {
        const observer = new MutationObserver(function(mutations) {
            let shouldReapply = false;
            
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) { // Element node
                            // Check if new forms or form-like elements were added
                            if (node.matches && (
                                node.matches('form') ||
                                node.matches('[class*="form"]') ||
                                node.matches('.globo-formbuilder') ||
                                node.querySelector('form') ||
                                node.querySelector('.globo-formbuilder') ||
                                node.querySelector('[class*="form"]')
                            )) {
                                shouldReapply = true;
                            }
                        }
                    });
                }
            });
            
            if (shouldReapply) {
                setTimeout(() => {
                    console.log('Order Masking: New forms detected, reapplying masks');
                    applyOrderIdMaskToAllForms();
                }, 100);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Initialize the masking system
    function init() {
        console.log('Order Masking: Initializing for .amazon-id and .walmart-id classes...');
        
        // Apply masks immediately if DOM is ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', applyOrderIdMaskToAllForms);
        } else {
            applyOrderIdMaskToAllForms();
        }
        
        // Set up observer for dynamic content
        observeForNewForms();
        
        // Listen for custom form events (like Globo Form Builder)
        document.addEventListener('globo.formbuilder.form.loaded', function(e) {
            console.log('Order Masking: Globo form loaded, applying masks');
            setTimeout(() => applyOrderIdMaskToAllForms(), 100);
        });
        
        // Listen for common dynamic content events
        document.addEventListener('shopify:section:load', function(e) {
            console.log('Order Masking: Shopify section loaded, applying masks');
            setTimeout(() => applyOrderIdMaskToAllForms(), 100);
        });
        
        // Backup timers for async-loaded forms (extended for form builders)
        setTimeout(() => {
            console.log('Order Masking: 1 second backup check');
            applyOrderIdMaskToAllForms();
        }, 1000);
        
        setTimeout(() => {
            console.log('Order Masking: 3 second backup check');
            applyOrderIdMaskToAllForms();
        }, 3000);
        
        setTimeout(() => {
            console.log('Order Masking: 5 second backup check (for slow form builders)');
            applyOrderIdMaskToAllForms();
        }, 5000);
        
        // Listen for toggle/tab changes that might reveal new forms
        document.addEventListener('click', function(e) {
            if (e.target.matches('.toggle-option-label') || 
                e.target.closest('.toggle-switch') ||
                e.target.matches('[data-toggle]') ||
                e.target.matches('.tab-link') ||
                e.target.closest('.tabs')) {
                setTimeout(() => {
                    console.log('Order Masking: Toggle/tab detected, reapplying masks');
                    applyOrderIdMaskToAllForms();
                }, 300);
            }
        });
    }

    // Export for manual use if needed
    window.applyOrderIdMaskToAllForms = applyOrderIdMaskToAllForms;
    
    // Start the system
    init();
})();